export default __webpack_public_path__ + "static/media/Hospitais.acd69280.png";